import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@emotion/react';
import { cleanCommonProps, getStyleProps } from '../utils';
export const inputCSS = ({
  isDisabled,
  value,
  theme: {
    spacing,
    colors
  }
}, unstyled) => ({
  visibility: isDisabled ? 'hidden' : 'visible',
  // force css to recompute when value change due to @emotion bug.
  // We can remove it whenever the bug is fixed.
  transform: value ? 'translateZ(0)' : '',
  ...containerStyle,
  ...(unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  })
});
const spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
const containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': {
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre',
    ...spacingStyle
  }
};
const inputStyle = isHidden => ({
  label: 'input',
  color: 'inherit',
  background: 0,
  opacity: isHidden ? 0 : 1,
  width: '100%',
  ...spacingStyle
});
const Input = props => {
  const {
    cx,
    value
  } = props;
  const {
    innerRef,
    isDisabled,
    isHidden,
    inputClassName,
    ...innerProps
  } = cleanCommonProps(props);
  return jsx("div", _extends({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), jsx("input", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Input;